module.exports = __webpack_public_path__ + "img/promotion_03.1a8242ae.png";